/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import CodeableConceptEntry, { DisplayFromFHIRCodeableConcept, simpleDisplayStringFromFHIRCodeableConcept } from "../datatypeComponents/CodeableConceptEntry";
import { displayStringFromFHIRReference } from "../datatypeComponents/ReferenceEntry";
import ExpandToAddOrEdit from "../components/ExpandToAddOrEdit";
import { convertValueSetToCodeableConceptSet } from "../dictionaries/THOandFHIRValueSets";
import ArrayEntry from "../datatypeComponents/ArrayEntry";

const evidenceClassificationTypeValueSet = [
    {
        "system": "https://fevir.net/resources/CodeSystem/179423",
        "code": "population",
        "display": "Population"
    },
    {
        "system": "https://fevir.net/resources/CodeSystem/179423",
        "code": "intervention",
        "display": "Intervention"
    },
    {
        "system": "https://fevir.net/resources/CodeSystem/179423",
        "code": "comparator",
        "display": "Comparator"
    },
    {
        "system": "https://fevir.net/resources/CodeSystem/179423",
        "code": "outcome-measure",
        "display": "Outcome Measure"
    },
    {
        "system": "http://terminology.hl7.org/CodeSystem/usage-context-type",
        "code": "age",
        "display": "Age Range"
    },
    {
        "system": "http://terminology.hl7.org/CodeSystem/usage-context-type",
        "code": "gender",
        "display": "Gender"
    }
];

const EvidenceClassificationEntry = ({ elementName, fieldLabel, startingValue,
    setResourceState, startCollapsed, containedResourceDictionary = {} }) => {

    const [evidenceClassificationState, setEvidenceClassificationState] = useState({});
    const [startCollapsedState, setStartCollapsedState] = useState(startCollapsed);

    useEffect(() => {
        let startingEvidenceClassification = {
            type: "", classifier: []
        }
        if (startingValue) {
            if (startingValue.extension) { startingEvidenceClassification.extension = startingValue.extension; }
            if (startingValue.type) { startingEvidenceClassification.type = startingValue.type; }
            if (startingValue.classifier) { startingEvidenceClassification.classifier = startingValue.classifier; }
        }
        setEvidenceClassificationState(JSON.parse(JSON.stringify(startingEvidenceClassification)));
    }, []);

    useEffect((() => {
        if (Object.keys(evidenceClassificationState).length > 0) {
            let newEvidenceClassification = {};
            if (evidenceClassificationState.extension) { newEvidenceClassification.extension = evidenceClassificationState.extension; }
            if (evidenceClassificationState.type && Object.keys(evidenceClassificationState.type).length > 0) {
                newEvidenceClassification.type = evidenceClassificationState.type;
            }
            if (Array.isArray(evidenceClassificationState.classifier) && evidenceClassificationState.classifier.length > 0 &&
                Object.keys(evidenceClassificationState.classifier[0]).length > 0) {
                newEvidenceClassification.classifier = evidenceClassificationState.classifier;
            }
            if (Object.keys(newEvidenceClassification).length === 0) {
                newEvidenceClassification = null;
            }
            setResourceState(prevState => { return { ...prevState, [elementName]: newEvidenceClassification }; });
        }
    }), [evidenceClassificationState]);

    if (startCollapsedState) {
        return <div>
            <b>{fieldLabel}: </b>
            {startingValue && <div style={{ marginLeft: "24px" }}>
                {startingValue.type && <span><b>Type: </b><DisplayFromFHIRCodeableConcept codeableConcept={startingValue.type} /></span>}
                {(startingValue.classifier && Array.isArray(startingValue.classifier) && startingValue.classifier.length > 0) &&
                    <div>
                        <b>Classifier(s): </b>
                        {startingValue.classifier.map((classifier, classifierIndex) => {
                            return <span key={classifierIndex}>
                                {classifier.concept && <>{simpleDisplayStringFromFHIRCodeableConcept(classifier.concept)}</>}
                                {(classifier.concept && classifier.reference) && <>, </>}
                                {classifier.reference && <>{displayStringFromFHIRReference(classifier.reference)}</>}
                                {(startingValue.classifier.length > classifierIndex + 1) && <>; </>}
                            </span>
                        })}
                    </div>}
            </div>}
            &nbsp;&nbsp;
            <ExpandToAddOrEdit startingValue={startingValue} setStartCollapsedState={setStartCollapsedState} />
        </div >
    } else if (Object.keys(evidenceClassificationState).length > 0) {
        return <>
            <p style={{ marginBottom: "0px" }}><b>{fieldLabel}: </b></p>
            <div style={{ marginLeft: "24px" }}>
                <CodeableConceptEntry elementName='type'
                    fieldLabel='Type'
                    startingValue={evidenceClassificationState.type}
                    codeableConceptLevelValueSet={convertValueSetToCodeableConceptSet(evidenceClassificationTypeValueSet)}
                    setResourceState={setEvidenceClassificationState} />
                <ArrayEntry datatype="CodeableReference" elementName='classifier'
                    containedResourceDictionary={containedResourceDictionary}
                    fieldLabel='Classifier' deletable deletableArray startCollapsed
                    startingValue={evidenceClassificationState.classifier}
                    setResourceState={setEvidenceClassificationState} />
            </div>
        </>
    }
};

export default EvidenceClassificationEntry;